import { useQuery } from '@tanstack/react-query';
import { PlanningTypes } from 'pages/admin/demand/planning/context/types/contextPrevision.type';
import alb from 'services/api/alb';

import { IFilterHierarchy } from '../types/planning.types';
import { serializeFilters } from '../utils/filterSerialization';
import { buildFiltersPayload } from '../utils/planningByLevelUtils';
export interface IGetPlanning {
	planningType: PlanningTypes;
	cycleId: number;
	companyAreaId?: number;
	filters?: IFilterHierarchy;
}
interface IGetSetupResponse {
	month_year: string;
	quantity: number;
}

export const getPlanning = async (
	params: IGetPlanning
): Promise<IGetSetupResponse[]> => {
	const { planningType, cycleId, companyAreaId, filters } = params;

	const url = `/${planningType}/find`;

	// alterado para alb devido timeout na agelus
	const response = await alb.post<{ rows: IGetSetupResponse[] }>(
		url,
		buildFiltersPayload({ cycleId, filters, companyAreaId })
	);

	return response.data.rows;
};

export const useGetPlanning = (params: IGetPlanning) => {
	const serializedFilters = serializeFilters(params.filters);

	return useQuery({
		queryKey: [
			'planning',
			params.planningType,
			params.cycleId,
			serializedFilters,
		],
		queryFn: () => getPlanning(params),
		enabled: !!params.cycleId && !!params.filters,
		retryOnMount: false,
		refetchOnWindowFocus: false,
	});
};
